/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum InsightsInterval {
  day="day",
week="week",
month="month"
}

/**
* InsightsInterval
*/
export const InsightsIntervalEnumType = types.enumeration("InsightsInterval", [
        "day",
  "week",
  "month",
      ])
